import { Sparkles } from "lucide-react";
import { RecommendationBadge } from "./RecommendationBadge";
import type { Recommendation } from "@/types";

export function VerdictPanel({
  recommendation,
  texto,
  origen,
}: {
  recommendation: Recommendation;
  texto: string;
  origen: "ia" | "deterministico";
}) {
  return (
    <section className="rounded-xl border border-border bg-card p-5 shadow-elegant">
      <header className="flex items-center gap-2 mb-3">
        <Sparkles className="size-4 text-primary" />
        <h3 className="font-display font-semibold">Veredicto ejecutivo</h3>
        <RecommendationBadge value={recommendation} size="sm" />
      </header>
      {texto ? (
        <p className="text-sm leading-relaxed text-foreground whitespace-pre-line">{texto}</p>
      ) : (
        <p className="text-sm text-muted-foreground">
          {origen === "ia"
            ? "El motor no redactó un veredicto para esta evaluación."
            : "Este resultado proviene del análisis base. Ejecuta el análisis IA para obtener el veredicto redactado."}
        </p>
      )}
    </section>
  );
}
